import { API } from 'apis';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { PaginationList, TeamSelectionUser, WorldCupTeam } from 'core/domain';
import toast from 'react-hot-toast';

export const getAllTeams = async (setLoading: any, setData: any) => {
    setLoading(true);
    await getViaAuth<WorldCupTeam[]>(API.worldCupTeams.getAll).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            if (response.value) {
                setData(response.value);
            }
        }
    });
};

export const getTeamSelectionUsers = async (
    setLoading: any,
    setData: any,
    page: number,
    pageSize: number,
    query?: string,
    setAccessDenied?: any,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<TeamSelectionUser>>(
        `${API.worldCupTeams.selectionUsers}/${page}/${pageSize}${query || ''}`,
    ).then((response: any) => {
        setLoading(false);
        if (response.status === 401 || response.status === 403) {
            setAccessDenied && setAccessDenied(true);
            return;
        }
        if (responseValidator(response.status) && response.value) {
            setData(response.value);
        }
    });
};

export const updateTeamIsWin = async (
    setLoading: any,
    id: number,
    isWin: boolean,
    onSuccess?: () => void,
) => {
    setLoading(true);
    await postViaAuth(API.worldCupTeams.updateIsWin, { id, isWin })
        .then((response: any) => {
            if (responseValidator(response.status)) {
                toast.success('وضعیت تیم با موفقیت تغییر کرد');
                onSuccess && onSuccess();
            }
        })
        .finally(() => {
            setLoading(false);
        });
};
